import React, { useState } from 'react'
import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image'
import Box from '@mui/material/Box'
import { SvgIcon, Typography } from '@mui/material'
import ZoomIcon from '../../../../../static/Zoom-in-light.svg'
import UrlIcon from '../../../../../static/External-link-light.svg'
import EntryIcon from '../../../../../static/Arrow-right-light.svg'
import DialogImage from '../DialogImage'
import { HelpImageProps } from './HelpImage.types'
import useSanitizedSlug from '../../../../hooks/useSanitizedSlug'
import { Link } from 'gatsby'
import { useTheme } from '@mui/material/styles'

const HelpImage = ({ alt, image, width, height, border, scale, visualDescription, targetUrl }: HelpImageProps) => {
  const { palette } = useTheme()

  const styles = {
    imageContainer: {
      position: 'relative',
      display: 'inline-block',
      width: width || '100%',
      height: height || 'Auto',
      textAlign: 'center',
      maxWidth: '100%',
    },
    image: {
      display: 'block',
      width: '100%',
      objectfit: 'contain',
      border: border ? `solid 10px ${palette.grey[300]}` : 'none',
      borderRadius: visualDescription?.visualDescription && border ? '6px 6px 0 0' : '6px',
      cursor: scale || !!targetUrl ? 'pointer' : 'default',
    },
    iconOverlay: {
      position: 'absolute',
      top: '15px',
      right: '15px',
      color: palette.grey[500],
      borderRadius: '3px',
      padding: '3px',
      background: palette.grey[300],
    },
    visualDescription: {
      display: 'block',
      background: border ? palette.grey[300] : 'none',
      paddingBottom: '10px',
      paddingTop: !border ? '5px' : 0,
      textAlign: 'center',
      borderRadius: '0 0 6px 6px',
      boxSizing: 'border-box',
    },
  }
  const [openModal, setOpenModal] = useState(false)
  const handleOpen = () => setOpenModal(true)
  const handleClose = () => setOpenModal(false)
  const imageContentTypes = ['image/gif', 'image/svg+xml', 'image/png', 'image/jpg', 'image/jpeg']
  const url = targetUrl?.startsWith('https://tdc.dk/') ? targetUrl.replace('https://tdc.dk', '') : targetUrl // prevent local and staging linking to tdc
  const target = url && !url.startsWith('http') ? useSanitizedSlug(`/kundeservice/${targetUrl}`) : url ? url : null
  const targetIcon = url && !url.startsWith('http') ? EntryIcon : url ? UrlIcon : null
  if (imageContentTypes.includes(image?.file?.contentType)) {
    return (
      <>
        <Box sx={styles.imageContainer}>
          {target ? (
            <Box component={Link} to={target}>
              <img src={image?.file.url || ''} alt={alt || ''} style={styles.image}></img>
              <SvgIcon component={targetIcon} sx={styles.iconOverlay} viewBox={'0 0 48 48'} />
            </Box>
          ) : scale ? (
            <Box onClick={handleOpen}>
              <img src={image?.file.url || ''} alt={alt || ''} style={styles.image}></img>
              <SvgIcon component={ZoomIcon} sx={styles.iconOverlay} viewBox={'0 0 48 48'} />
            </Box>
          ) : (
            <img src={image?.file.url || ''} alt={alt || ''} style={styles.image}></img>
          )}
          {visualDescription?.visualDescription && (
            <Typography sx={styles.visualDescription}>{visualDescription?.visualDescription}</Typography>
          )}
        </Box>
        {openModal && (
          <DialogImage
            image={image}
            alt={alt}
            handleClose={handleClose}
            open={openModal}
            visualDescription={visualDescription}
          />
        )}
      </>
    )
  }
  return <GatsbyImage image={getImage(image?.gatsbyImageData) as IGatsbyImageData} alt={alt || ''} />
}

export default HelpImage
